import { takeEvery, put, call } from "redux-saga/effects"

// Calender Redux States
import {
    GET_INQUIRY_LISTING,
    ADD_INQUIRY,
    UPDATE_INQUIRY,
    DELETE_INQUIRY,
    DETAILS_LISTING_INQUIRY,
    GET_INQUIRY_DETAILS,
} from "./actionTypes.js";

import {
    getInquiryListingSuccess,
    getInquiryListingFail,
    getInquiryDetailsSuccess,
    createInquirySuccess,
    createInquiryFail,
    updateInquirySuccess,
    updateInquiryFail,
    deleteInquirySuccess,
    deleteInquiryFail,
    detailListingInquirySuccess,
    detailListingInquiryFail,
    getInquiryDetailsFail,
} from "./actions.js";

import {
    inquiryListingApi,
    inquiryDetailsApi,
    addInquiryApi,
    updateInquiryApi,
    deleteInquiryApi,
    detailListingInquiryApi,
} from "./inquiryApi.js";

function* fetchInquiryListing({ payload }) {
    try {
        const response = yield call(inquiryListingApi, payload);
        yield put(getInquiryListingSuccess(response));
    } catch (error) {
        yield put(getInquiryListingFail(error));
    }
}

function* fetchInquiryDetail({ payload }) {
    try {
        const response = yield call(inquiryDetailsApi, payload);
        yield put(getInquiryDetailsSuccess(response));
    } catch (error) {
        yield put(getInquiryDetailsFail(error));
    }
}

function* createInquiry({ payload }) {
    try {
        const response = yield call(addInquiryApi, payload);
        yield put(createInquirySuccess(response));
    } catch (error) {
        yield put(createInquiryFail(error));
    }
}

function* updateInquiry({ payload }) {
    try {
        const response = yield call(updateInquiryApi, payload);
        yield put(updateInquirySuccess(response));
    } catch (error) {
        yield put(updateInquiryFail(error));
    }
}

function* deleteInquiry({ payload }) {
    try {
        const response = yield call(deleteInquiryApi, payload);
        yield put(deleteInquirySuccess(response));
    } catch (error) {
        yield put(deleteInquiryFail(error));
    }
}

function* detailListingInquiry({ payload }) {
    try {
        const response = yield call(detailListingInquiryApi, payload);
        yield put(detailListingInquirySuccess(response));
    } catch (error) {
        yield put(detailListingInquiryFail(error));
    }
}

function* InquirySaga() {
    yield takeEvery(GET_INQUIRY_LISTING, fetchInquiryListing);
    yield takeEvery(GET_INQUIRY_DETAILS, fetchInquiryDetail);
    yield takeEvery(ADD_INQUIRY, createInquiry);
    yield takeEvery(UPDATE_INQUIRY, updateInquiry);
    yield takeEvery(DELETE_INQUIRY, deleteInquiry);
    yield takeEvery(DETAILS_LISTING_INQUIRY, detailListingInquiry);

}

export default InquirySaga
